// extracted by mini-css-extract-plugin
export var rating = "default-module__rating___LhvGE";